module.exports = __webpack_public_path__ + "media/images/icon__burger-menu-d445e8a8fb44f483134970cabe942c73.png";